import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(message) {
        this.w49_1 = message;
        this.x49_1 = null;
        this.y49_1 = null;
        this.z49_1 = null;
        this.a4a_1 = null;
      }
      b4a(locations) {
        // Inline function 'kotlin.apply' call
        this.x49_1 = locations;
        return this;
      }
      c4a(path) {
        // Inline function 'kotlin.apply' call
        this.y49_1 = path;
        return this;
      }
      q44(extensions) {
        // Inline function 'kotlin.apply' call
        this.a4a_1 = extensions;
        return this;
      }
      d4a(nonStandardFields) {
        // Inline function 'kotlin.apply' call
        this.z49_1 = nonStandardFields;
        return this;
      }
      l38() {
        return new (Error_0())(this.w49_1, this.x49_1, this.y49_1, this.a4a_1, this.z49_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var LocationClass;
function Location() {
  if (LocationClass === VOID) {
    class $ {
      constructor(line, column) {
        this.e4a_1 = line;
        this.f4a_1 = column;
      }
      toString() {
        return 'Location(line = ' + this.e4a_1 + ', column = ' + this.f4a_1 + ')';
      }
    }
    initMetadataForClass($, 'Location');
    LocationClass = $;
  }
  return LocationClass;
}
var ErrorClass;
function Error_0() {
  if (ErrorClass === VOID) {
    class $ {
      constructor(message, locations, path, extensions, nonStandardFields) {
        this.g4a_1 = message;
        this.h4a_1 = locations;
        this.i4a_1 = path;
        this.j4a_1 = extensions;
        this.k4a_1 = nonStandardFields;
      }
      toString() {
        return 'Error(message = ' + this.g4a_1 + ', locations = ' + toString(this.h4a_1) + ', path=' + toString(this.i4a_1) + ', extensions = ' + toString(this.j4a_1) + ', nonStandardFields = ' + toString(this.k4a_1) + ')';
      }
    }
    initMetadataForClass($, 'Error');
    ErrorClass = $;
  }
  return ErrorClass;
}
//region block: exports
export {
  Builder as Builder3gaff1pwujyid,
  Location as Location25t453jk43ktl,
};
//endregion

//# sourceMappingURL=Error.mjs.map
